import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '52b70d0f1902e104f9fc306d7ddee7a7.png',
	fr: '2892ef8dd66515dbddc04c88b7fca3ee.png',
};

export const ShakerSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading
						as="h2"
						dangerouslySetInnerHTML={{
							__html: t('unloggedhomepage_title_shakerfeature_standalone-web', {
								ns: 'features',
							}),
						}}
					/>
					<LandingParagraph>
						{t('unloggedhomepage_text_shakerfeature_standalone-web', {
							ns: 'features',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="2880/1012"
					src={src}
					alt={t('metatag_text_highfidelitymusic_standalone-web', {
						ns: 'common',
					})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'shaker'}}
					href="/features/shaker"
				>
					{t('musictogether_action_tryshaker_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
